export default __webpack_public_path__ + "static/dedicated-dev-team-729a36b484a719fd20b200f39d614100.svg";